import moment from "moment-timezone";

/**
 * Format TeleCMI call time for Call Logs (Asia/Kolkata).
 * Prefer CDR `time` (ISO UTC from epoch); fall back to createdAt.
 * utcOffset(+330) avoids missing moment-timezone data edge cases.
 */
export const getCallMoment = (recordOrValue) => {
  const value =
    recordOrValue && typeof recordOrValue === "object"
      ? recordOrValue.time || recordOrValue.createdAt
      : recordOrValue;

  if (!value) return null;

  const raw = String(value).trim();
  // Numeric epoch (sec or ms)
  if (/^\d+$/.test(raw)) {
    let n = Number(raw);
    if (n < 1e12) n *= 1000;
    return moment.utc(n).utcOffset(330);
  }

  const m = moment.utc(raw);
  if (!m.isValid()) {
    const local = moment(raw);
    return local.isValid() ? local.utcOffset(330, true) : null;
  }
  return m.utcOffset(330);
};

export const formatCallDate = (recordOrValue) => {
  const m = getCallMoment(recordOrValue);
  return m ? m.format("DD/MM/YYYY") : "-";
};

export const formatCallTime = (recordOrValue) => {
  const m = getCallMoment(recordOrValue);
  return m ? m.format("hh:mm A") : "-";
};
